// utils/kennitala.ts
export function isValidKennitala(value: string): boolean {
  if (!value) return false

  const kt = value.replace(/[^0-9]/g, '')
  if (kt.length !== 10) return false

  const weights = [3, 2, 7, 6, 5, 4, 3, 2]
  let sum = 0

  for (let i = 0; i < 8; i++) {
    sum += parseInt(kt[i], 10) * weights[i]
  }

  const remainder = sum % 11
  const checkDigit = remainder === 0 ? 0 : 11 - remainder

  return checkDigit === parseInt(kt[8], 10)
}
